import {Pipe, PipeTransform} from '@angular/core';
import {Diensten} from './diensten';

@Pipe({
    name: 'zahDiensten',
    standalone: false
})
export class DienstenPipe implements PipeTransform {
  transform(dienstIds: Array<string>, diensten: Diensten): string {
    if (!diensten) {
      return '';
    } else {
      const dienstLabels = (dienstIds || [])
        .map(dienstId => diensten.getDienst(dienstId))
        .filter(dienst => !!dienst)
        .map(dienst => dienst.getLabel());
      return dienstLabels.length > 0 ? dienstLabels.join(', ') : 'Geen dienst';
    }
  }
}
